// tokenDataSlice.js
import { createSlice } from '@reduxjs/toolkit'
import axios from 'axios'

const initialState = {
  tokenData:null,
  audit:null,
  auditLoading:false,
  auditError:false,
  loadingStates: false, // Separate loading state per token
  errors: false,
  metadata:null,
  
  // Separate error state per token
}

export const tokenDataSlice = createSlice({
  name: 'tokenData',
  initialState,
  reducers: {
    setTokenData: (state, action) => {
        state.tokenData ={...state.tokenData, ...action.payload}
    },
    setTokenAudit: (state, action) => {
        state.audit ={...state.audit,...action.payload}
    },
    setLoadingState: (state, action) => {
      state.loadingStates = action.payload
    },
    setAuditLoading: (state, action) => {
      state.auditLoading = action.payload
    },
    setAuditError: (state, action) => {
      state.auditError = action.payload
    },
    setError: (state, action) => {
      state.errors = action.payload
    }
  }
})

export const { setTokenData, setLoadingState, setError ,setTokenAudit ,setAuditLoading,setAuditError} = tokenDataSlice.actions



// Memoized selectors
export const selectTokenData = (state, address) => state.tokenData.tokenData
export const selectTokenAudit = (state, address) => state.tokenData.audit
export const selectTokenLoading = (state, address) => state.tokenData.loadingStates
export const selectTokenError = (state, address) => state.tokenData.errors
export const selectAuditError = (state, address) => state.tokenData.auditError
export const selectAuditLoading = (state, address) => state.tokenData.auditLoading